/**
 * @param {jQuery} $ jQuery object.
 */
(function( $ ) {

	/**
	 * Infinite Scroll.
	 *
	 * @since 1.0.0
	 * @type {object}
	 */
	var self = Astoundify.InfiniteScroll = _.extend( {}, {
		action: 'astoundify_infinite_scroll_load_more',
		base_url: '',
		paged: 1,
		query: {},
		loading: false,
		l10n: {
			loading: 'Loading...',
			load: 'Load More',
			error: 'Error'
		}
	}, Astoundify.InfiniteScroll || {} );

	/**
	 * Are we currently loading new posts?
	 *
	 * @since 1.0.0
	 * @type {bool}
	 */
	self.isLoading = function() {
		return self.loading;
	};

	/**
	 * Load more posts.
	 *
	 * @since 1.0.0
	 */
	self.loadMore = function() {
		if ( self.isLoading() ) {
			return;
		}

		self.loading = true;

		self.paged = self.paged + 1;

		var data = {
			_wpnonce: self.$trigger.data( '_wpnonce' ),
			query: self.query,
			paged: self.paged,
			base_url: self.base_url
		};

		wp.ajax.post( self.action, data ).done( function( response ) {
			// update button
			if ( false === response.more_pages ) {
				self.$trigger.parent().hide();
			} else {
				self.$trigger.attr( 'disabled', false );
				self.$trigger.text( self.l10n.load );
			}

			window.history.pushState( null, null, decodeURIComponent( response.next_url ) );

			// append items
			if ( '' !== response.html ) {
				var items = $.parseHTML( response.html );

				if ( self.$target.data( 'columns' ) ) {
					salvattore.appendElements( document.querySelector( self.target ), items );
				} else {
					self.$target.append( items );
				}
			}
		}).always( function() {
			self.loading = false;
		}).fail( function() {
			self.$trigger.text( self.l10n.error );
		});
	};

	/**
	 * Bind actions to DOM ready.
	 *
	 * @since 1.0.0
	 */
	$(document).ready(function() {
		$( '#js-load-more' ).on( 'click', function(e) {
			e.preventDefault();

			// find out where we are adding this stuff
			self.$trigger = $(this);

			self.target = $(this).data( 'target' );
			self.$target = $(self.target);

			self.$trigger.attr( 'disabled', true );
			self.$trigger.text( self.l10n.loading );

			self.loadMore();
		});
	});

})( jQuery );
